// Centralny słownik tłumaczeń interfejsu.
// Klucze w formacie 'obszar.element' ułatwiają późniejszą migrację (np. na react-i18next).
// Interpolacja parametrów: użyj {{nazwa}} w wartości i przekaż t('klucz', { nazwa: wartosc }).
// Dodanie nowego języka = dodanie kodu do SUPPORTED_LANGUAGES i nowego obiektu w translations.

export const DEFAULT_LANGUAGE = 'pl';

export const SUPPORTED_LANGUAGES = [
  { code: 'pl', label: 'Polski' },
  { code: 'en', label: 'English' },
];

export const translations = {
  pl: {
    'app.title': 'Szacowanie szkód łowieckich',
    'app.subtitle': 'Prześlij GeoTIFF, pozaznaczaj szkody i sporządź raport.',
    'app.logoAlt': 'AirHaiku logo',
    'language.switcherLabel': 'Język',
    'fileUpload.choose': '📂 Wybierz plik GeoTIFF',
    'fileUpload.processing': '⏳ Przetwarzanie...',

    'inspectionDialog.title': 'Dane z oględzin wstępnych',
    'inspectionDialog.description': 'Jeśli przed szacowaniem przeprowadzono oględziny, możesz zapisać ustalony wtedy poziom zniszczeń.',
    'inspectionDialog.percentLabel': 'Zniszczenia z oględzin wstępnych',
    'inspectionDialog.note': 'Ta wartość jest obecnie informacją pomocniczą i nie wpływa na obliczenie szkody końcowej.',
    'inspectionDialog.skip': 'Pomiń oględziny',
    'inspectionDialog.continue': 'Dalej do pliku',

    'common.cancel': 'Anuluj',
    'common.noData': 'brak danych',

    'map.aoi.buttonTitle': 'Uzyj calego GeoTIFF jako AOI 100%',
    'map.geotiff.tileError': 'Nie udało się wczytać kafelków GeoTIFF. Sprawdź połączenie z backendem i otwórz pole ponownie.',
    'map.geotiff.preparingAoi': 'Wyznaczanie AOI z GeoTIFF...',
    'field.error.aoiFailed': 'Nie udało się wyznaczyć AOI: {{message}}',
    'field.error.loadTimeout': 'Serwer nie odpowiedział w ciągu 30 sekund. Spróbuj ponownie otworzyć pole.',
    'map.exclusion.buttonTitle': 'Tryb wyłączeń: rysuj obszary odejmowane od całej powierzchni pola (100%)',
    'map.popup.fieldReference': 'Punkt referencyjny pola',
    'map.basemap.desktopHint': 'Aby mapa dzialala offline wystarczy ten obszar obejrzeć mając dostęp do sieci.',
    'map.basemap.offlineFallback': 'Podklad online jest teraz niedostepny. Aplikacja dalej dziala lokalnie na GeoTIFF i wykorzysta tylko te kafle, ktore sa juz zapisane w cache.',
    'map.basemap.offlineOverlay': 'Brak dostepu do podkladu online. Praca trwa na GeoTIFF i lokalnym cache.',

    'upload.progress.sending': 'Wysyłanie pliku na...',
    'upload.progress.loading': 'Ładowanie...',
    'upload.progress.compression': 'Kompresja: {{original}}MB -> {{compressed}}MB',
    'upload.progress.downloading': 'Pobieranie skompresowanego pliku...',
    'upload.progress.rendering': 'Renderowanie na mapie...',
    'upload.progress.creatingField': 'Tworzenie pola...',
    'upload.progress.done': 'Gotowe',
    'upload.progress.movingToField': 'Przenoszenie do lokalizacji pola...',
    'upload.progress.loadingFromReport': 'Ładowanie GeoTIFF z raportu: {{filename}}...',
    'upload.progress.downloadDone': 'Pobieranie zakończone. Renderowanie mapy...',
    'upload.progress.movingToSelected': 'Przenoszenie do wybranego pola...',

    'upload.error.tooBig':
      'Błąd ładowania GeoTIFF: aplikacja odrzuciła plik (413 Request Entity Too Large).{{sizeInfo}} Sprawdź limity uploadu na host nginx i w kontenerze web (client_max_body_size), a następnie wykonaj nginx -t oraz reload nginx na VPS.',
    'upload.error.fileSize': ' Rozmiar pliku: {{sizeMb}} MB.',
    'upload.error.generic': 'Błąd ładowania GeoTIFF: {{message}}',

    'field.error.needGeotiff': 'Najpierw załaduj poprawny GeoTIFF, aby ustawić AOI na 100%.',
    'field.error.mapNotReady': 'Mapa nie jest jeszcze gotowa. Spróbuj ponownie za chwilę.',
    'field.error.boundsFailed': 'Nie udało się wyznaczyć granic GeoTIFF w układzie WGS84.',
    'field.error.locationFailed': 'Nie udało się ustalić lokalizacji pola z GeoTIFF.',
    'field.error.createFailed': 'Nie udało się utworzyć pola po wgraniu GeoTIFF.',
    'field.error.cropInside': 'Crop musi znajdować się w całości wewnątrz pola (krok 1).',
    'field.error.exclusionInside': 'Wyłączenie musi znajdować się w całości wewnątrz pola (AOI).',
    'field.error.cropsInsideAfterEdit': 'Po edycji wszystkie cropy muszą pozostać wewnątrz pola.',
    'field.error.cropsOverlap': 'Spoty nie mogą się nakładać. Popraw ich granice, aby powierzchnia i szkoda nie zostały policzone podwójnie.',
    'field.error.invalidDamageGeometry': 'Nie można rzetelnie obliczyć szkody: sprawdź, czy spoty nie nakładają się i mieszczą się w polu.',
    'field.error.saveStateFailed': 'Nie udało się zapisać stanu pola.',
    'field.error.restoreFailed': 'Nie udało się odtworzyć raportu na mapie: {{message}}',
    'field.error.nameEmpty': 'Nazwa raportu nie może być pusta.',
    'field.error.renameFailed': 'Nie udało się zmienić nazwy raportu.',
    'field.error.notesFailed': 'Nie udało się zmienić uwag raportu.',
    'field.error.detailsFailed': 'Nie udało się zapisać danych pola.',
    'field.error.deleteFailed': 'Nie udało się usunąć raportu.',

    'field.confirmDelete': 'Usunąć raport "{{title}}"?',

    'field.list.header': 'Pola ({{count}})',
    'field.list.empty': 'Brak pól.',
    'field.accordion.expand': 'Rozwiń szczegóły pola',
    'field.accordion.collapse': 'Zwiń szczegóły pola',
    'field.defaultName': 'Pole {{date}}',
    'field.coordinates.label': 'Współrzędne',
    'field.coordinates.openMaps': 'Otwórz w Google Maps',
    'field.saveName': 'Zapisz nazwę',
    'field.activeChip': 'Aktywne',
    'field.reportFallback': 'Raport {{id}}',
    'field.area100': 'Powierzchnia: 100% = {{area}}',
    'field.exclusions.summaryLabel': 'Wyłączenia ({{count}})',
    'field.exclusions.header': 'Wyłączenia z pola ({{count}})',
    'field.exclusions.hint': 'Włącz „Tryb wyłączeń" na mapie, aby zaznaczyć fragmenty pola wyłączone z powierzchni 100%.',
    'field.exclusions.modeOn': 'Tryb wyłączeń włączony — rysowane obszary są odejmowane od 100%. Kliknij ponownie przycisk na mapie, aby wrócić do rysowania spotów.',
    'field.exclusions.item': 'Wyłączenie {{number}}',
    'field.exclusions.delete': 'Usuń wyłączenie {{number}}',
    'field.areaFormat': '{{ha}} ha ({{ares}} a)',
    'field.damage': 'Uszkodzenie: {{percent}}% pola',
    'field.damageSuffix': ' — {{area}}',
    'field.inspectionDamage.label': 'Zniszczenia z oględzin wstępnych',
    'field.inspectionDamage.value': '{{percent}}%',
    'field.inspectionDamage.note': 'Dane wstępne — poza obliczeniem szkody końcowej',

    'field.remainderDamage.title': 'Ocena pozostałej części pola',
    'field.remainderDamage.badge': 'Uznaniowa',
    'field.remainderDamage.description': 'Procent dotyczy wyłącznie powierzchni AOI poza unią spotów. Nie jest naliczany na spotach.',
    'field.remainderDamage.percentLabel': 'Zniszczenie poza spotami',
    'field.remainderDamage.spotsArea': 'Łączna powierzchnia spotów',
    'field.remainderDamage.remainingArea': 'Powierzchnia poza spotami',
    'field.remainderDamage.spotsContribution': 'Szkoda wyliczona w spotach',
    'field.remainderDamage.remainingContribution': 'Szkoda uznaniowa poza spotami',
    'field.remainderDamage.activateToEdit': 'Aktywuj pole, aby zmienić wartość.',

    'field.cropType.label': 'Rodzaj uprawy',
    'field.cropType.unspecified': 'Nie wybrano',
    'field.cropType.corn': 'Kukurydza',
    'field.cropType.sugarBeet': 'Buraki cukrowe',
    'field.cropType.grain': 'Zboże',
    'field.cropType.rapeseed': 'Rzepak',
    'field.cropType.potatoes': 'Ziemniaki',
    'field.cropType.other': 'Inna uprawa',
    'field.owner.label': 'Właściciel pola',
    'field.owner.placeholder': 'Nazwisko',
    'field.details.save': 'Zapisz',

    'field.crops.header': 'Zaznaczone powierzchnie ({{count}})',
    'field.crops.empty': 'Brak zaznaczonych powierzchni na tym polu.',
    'field.crops.focusTitle': 'Przybliż do tego spotu na mapie',
    'field.crops.spot': 'Spot {{number}}',
    'field.crops.percentLabel': 'Procent zniszczenia',
    'field.crops.protectedSpeciesLabel': 'Szkoda spowodowana przez gatunek chroniony',
    'field.crops.estimatedDamage': 'Szacowana szkoda: {{area}}',
    'field.cropTransfer.title': 'Narzędzia developerskie — transfer cropów',
    'field.cropTransfer.export': 'Eksportuj cropy',
    'field.cropTransfer.import': 'Importuj cropy',
    'field.cropTransfer.description': 'Import zastępuje cropy aktywnego pola. Format: GeoJSON.',

    'field.notes.label': 'Uwagi',
    'field.notes.save': 'Zapisz uwagi',
    'field.notes.empty': 'Brak uwag.',

    'field.actions.showOnMap': 'Pokaż na mapie',
    'field.actions.export': 'Eksportuj raport',
    'field.actions.editName': 'Edytuj nazwę',
    'field.actions.editNotes': 'Edytuj uwagi',
    'field.actions.delete': 'Usuń pole',
    'field.actions.saveState': 'Zapisz stan',
  },
  en: {
    'app.title': 'Hunting damage assessment',
    'app.subtitle': 'Upload a GeoTIFF, mark the damage area and save a report.',
    'app.logoAlt': 'AirHaiku logo',
    'language.switcherLabel': 'Language',
    'fileUpload.choose': '📂 Choose GeoTIFF file',
    'fileUpload.processing': '⏳ Processing...',

    'inspectionDialog.title': 'Preliminary inspection data',
    'inspectionDialog.description': 'If a preliminary inspection was conducted before assessment, you can save the damage level determined at that time.',
    'inspectionDialog.percentLabel': 'Damage from preliminary inspection',
    'inspectionDialog.note': 'This value is currently for reference only and does not affect the final damage calculation.',
    'inspectionDialog.skip': 'Skip inspection',
    'inspectionDialog.continue': 'Continue to file',

    'common.cancel': 'Cancel',
    'common.noData': 'no data',

    'map.aoi.buttonTitle': 'Use the whole GeoTIFF as 100% AOI',
    'map.exclusion.buttonTitle': 'Exclusion mode: draw areas subtracted from the entire field area (100%)',
    'map.popup.fieldReference': 'Field reference point',
    'map.basemap.desktopHint': 'For the map to work offline in the field, view this area now while you have internet, so it gets saved on this computer.',
    'map.basemap.offlineFallback': 'The online basemap is currently unavailable. The app still works locally with the GeoTIFF and any tiles already stored in cache.',
    'map.basemap.offlineOverlay': 'Online basemap unavailable. Working from the GeoTIFF and local tile cache.',
    'map.geotiff.tileError': 'Could not load GeoTIFF tiles. Check the backend connection and reopen the field.',
    'map.geotiff.preparingAoi': 'Preparing AOI from GeoTIFF...',
    'field.error.aoiFailed': 'Could not prepare AOI: {{message}}',
    'field.error.loadTimeout': 'The server did not respond within 30 seconds. Try opening the field again.',

    'upload.progress.sending': 'Uploading file...',
    'upload.progress.loading': 'Loading...',
    'upload.progress.compression': 'Compression: {{original}}MB -> {{compressed}}MB',
    'upload.progress.downloading': 'Downloading compressed file...',
    'upload.progress.rendering': 'Rendering on the map...',
    'upload.progress.creatingField': 'Creating field...',
    'upload.progress.done': 'Done',
    'upload.progress.movingToField': 'Moving to the field location...',
    'upload.progress.loadingFromReport': 'Loading GeoTIFF from report: {{filename}}...',
    'upload.progress.downloadDone': 'Download complete. Rendering map...',
    'upload.progress.movingToSelected': 'Moving to the selected field...',

    'upload.error.tooBig':
      'GeoTIFF upload error: application rejected the file (413 Request Entity Too Large).{{sizeInfo}} Check the upload limits on the nginx host and in the web container (client_max_body_size), then run nginx -t and reload nginx on the VPS.',
    'upload.error.fileSize': ' File size: {{sizeMb}} MB.',
    'upload.error.generic': 'GeoTIFF upload error: {{message}}',

    'field.error.needGeotiff': 'Load a valid GeoTIFF first to set the AOI to 100%.',
    'field.error.mapNotReady': 'The map is not ready yet. Please try again in a moment.',
    'field.error.boundsFailed': 'Could not determine the GeoTIFF bounds in WGS84.',
    'field.error.locationFailed': 'Could not determine the field location from the GeoTIFF.',
    'field.error.createFailed': 'Could not create the field after uploading the GeoTIFF.',
    'field.error.cropInside': 'The crop must be located entirely inside the field (step 1).',
    'field.error.exclusionInside': 'The exclusion must be located entirely inside the field (AOI).',
    'field.error.cropsInsideAfterEdit': 'After editing, all crops must remain inside the field.',
    'field.error.cropsOverlap': 'Spots cannot overlap. Adjust their boundaries so area and damage are not counted twice.',
    'field.error.invalidDamageGeometry': 'Damage cannot be calculated reliably. Check that spots do not overlap and remain inside the field.',
    'field.error.saveStateFailed': 'Could not save the field state.',
    'field.error.restoreFailed': 'Could not restore the report on the map: {{message}}',
    'field.error.nameEmpty': 'The report name cannot be empty.',
    'field.error.renameFailed': 'Could not change the report name.',
    'field.error.notesFailed': 'Could not change the report notes.',
    'field.error.detailsFailed': 'Could not save the field details.',
    'field.error.deleteFailed': 'Could not delete the report.',

    'field.confirmDelete': 'Delete report "{{title}}"?',

    'field.list.header': 'Fields ({{count}})',
    'field.list.empty': 'No fields.',
    'field.accordion.expand': 'Expand field details',
    'field.accordion.collapse': 'Collapse field details',
    'field.defaultName': 'Field {{date}}',
    'field.coordinates.label': 'Coordinates',
    'field.coordinates.openMaps': 'Open in Google Maps',
    'field.saveName': 'Save name',
    'field.activeChip': 'Active',
    'field.reportFallback': 'Report {{id}}',
    'field.area100': '100% area: {{area}}',
    'field.exclusions.summaryLabel': 'Exclusions ({{count}})',
    'field.exclusions.header': 'Field exclusions ({{count}})',
    'field.exclusions.hint': 'Enable “Exclusion mode” on the map to mark parts of the field excluded from the 100% area.',
    'field.exclusions.modeOn': 'Exclusion mode is on — drawn areas are subtracted from 100%. Click the map button again to go back to drawing spots.',
    'field.exclusions.item': 'Exclusion {{number}}',
    'field.exclusions.delete': 'Delete exclusion {{number}}',
    'field.areaFormat': '{{ha}} ha ({{ares}} a)',
    'field.damage': 'Damage: {{percent}}% of the field',
    'field.damageSuffix': ' — {{area}}',
    'field.inspectionDamage.label': 'Preliminary inspection damage',
    'field.inspectionDamage.value': '{{percent}}%',
    'field.inspectionDamage.note': 'Preliminary data — excluded from the final damage calculation',

    'field.remainderDamage.title': 'Assessment of the remaining field',
    'field.remainderDamage.badge': 'Discretionary',
    'field.remainderDamage.description': 'This percentage applies only to AOI outside the union of spots. It is not applied within spots.',
    'field.remainderDamage.percentLabel': 'Damage outside spots',
    'field.remainderDamage.spotsArea': 'Combined spot area',
    'field.remainderDamage.remainingArea': 'Area outside spots',
    'field.remainderDamage.spotsContribution': 'Calculated damage within spots',
    'field.remainderDamage.remainingContribution': 'Discretionary damage outside spots',
    'field.remainderDamage.activateToEdit': 'Activate the field to change this value.',

    'field.cropType.label': 'Crop type',
    'field.cropType.unspecified': 'Not selected',
    'field.cropType.corn': 'Corn',
    'field.cropType.sugarBeet': 'Sugar beet',
    'field.cropType.grain': 'Grain',
    'field.cropType.rapeseed': 'Rapeseed',
    'field.cropType.potatoes': 'Potatoes',
    'field.cropType.other': 'Other crop',
    'field.owner.label': 'Field owner',
    'field.owner.placeholder': 'Last name',
    'field.details.save': 'Save',

    'field.crops.header': 'Marked areas ({{count}})',
    'field.crops.empty': 'No marked areas on this field.',
    'field.crops.focusTitle': 'Zoom to this spot on the map',
    'field.crops.spot': 'Spot {{number}}',
    'field.crops.percentLabel': 'Damage percent',
    'field.crops.protectedSpeciesLabel': 'Damage caused by a protected species',
    'field.crops.estimatedDamage': 'Estimated damage: {{area}}',
    'field.cropTransfer.title': 'Developer tools — crop transfer',
    'field.cropTransfer.export': 'Export crops',
    'field.cropTransfer.import': 'Import crops',
    'field.cropTransfer.description': 'Import replaces the active field crops. Format: GeoJSON.',

    'field.notes.label': 'Notes',
    'field.notes.save': 'Save notes',
    'field.notes.empty': 'No notes.',

    'field.actions.showOnMap': 'Show on map',
    'field.actions.export': 'Export report',
    'field.actions.editName': 'Edit name',
    'field.actions.editNotes': 'Edit notes',
    'field.actions.delete': 'Delete field',
    'field.actions.saveState': 'Save state',
  },
};
